import { FormBase } from 'core/components';

export default class ProcedureCodeUploadForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'file',
                    label: 'PROCEDURE_CODE.UPLOAD.FILE_LABEL',
                    placeholder: 'PROCEDURE_CODE.UPLOAD.FILE_PLACEHOLDER',
                    type:'file'
                }
            ],
        };
    }
}
